import React, { useCallback } from 'react';
import { IconButton, IconButtonTheme, IconButtonSize, Panel, PanelTheme } from '@apply/components';
import { faBell, faUserCircle, faTrashCan, faEdit } from '@fortawesome/free-regular-svg-icons';
import { DemoPage, DemoPageSection, DemoStack } from './common/DemoLayout';

export const IconButtonDemo: React.FC = () => {
    const buttonClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    return (
        <DemoPage title='Icon Button :'>
            <DemoPageSection title='White (Medium)'>
                <DemoStack>
                    <IconButton
                        id='White Bell Button With Count'
                        theme={IconButtonTheme.White}
                        handleClick={buttonClick}
                        size={IconButtonSize.Medium}
                        icon={faBell}
                        bubbleNumber={25}
                    />
                    <IconButton
                        id='White Profile Button With No Count'
                        theme={IconButtonTheme.White}
                        handleClick={buttonClick}
                        size={IconButtonSize.Medium}
                        icon={faUserCircle}
                        hint='View Profile'
                    />
                    <IconButton
                        id='White Profile Button Disabled'
                        theme={IconButtonTheme.White}
                        handleClick={buttonClick}
                        size={IconButtonSize.Medium}
                        icon={faUserCircle}
                        disabled={true}
                    />
                </DemoStack>
            </DemoPageSection>
            <DemoPageSection title='Transparent (Medium)'>
                <DemoStack>
                    <IconButton
                        id='Transparent Bell Button With Count'
                        theme={IconButtonTheme.Transparent}
                        handleClick={buttonClick}
                        size={IconButtonSize.Medium}
                        icon={faBell}
                        bubbleNumber={13}
                    />
                    <IconButton
                        id='Transparent Profile Button With No Count'
                        theme={IconButtonTheme.Transparent}
                        handleClick={buttonClick}
                        size={IconButtonSize.Medium}
                        icon={faUserCircle}
                        hint='View Profile'
                    />
                    <IconButton
                        id='Transparent Profile Button Disabled'
                        theme={IconButtonTheme.Transparent}
                        handleClick={buttonClick}
                        size={IconButtonSize.Medium}
                        icon={faUserCircle}
                        disabled={true}
                    />
                </DemoStack>
            </DemoPageSection>
            <DemoPageSection title='Red / Blue (Small, in a Panel)'>
                <Panel
                    theme={PanelTheme.White}
                    width='40px'
                >
                    <DemoStack>
                        <IconButton
                            id='Red Trash Button With Count'
                            theme={IconButtonTheme.Red}
                            handleClick={buttonClick}
                            size={IconButtonSize.Small}
                            icon={faTrashCan}
                            bubbleNumber={9}
                        />
                        <IconButton
                            id='Red Trash Button With No Count'
                            theme={IconButtonTheme.Red}
                            handleClick={buttonClick}
                            size={IconButtonSize.Small}
                            icon={faTrashCan}
                            hint='Delete Item'
                        />
                        <IconButton
                            id='Disabled Red Trash Button With No Count'
                            theme={IconButtonTheme.Red}
                            handleClick={buttonClick}
                            size={IconButtonSize.Small}
                            icon={faTrashCan}
                            hint='Delete Item'
                            disabled={true}
                        />
                        <IconButton
                            id='Blue Edit Button With Count'
                            theme={IconButtonTheme.Blue}
                            handleClick={buttonClick}
                            size={IconButtonSize.Small}
                            icon={faEdit}
                            bubbleNumber={3}
                        />
                        <IconButton
                            id='Blue Edit Button With No Count'
                            theme={IconButtonTheme.Blue}
                            handleClick={buttonClick}
                            size={IconButtonSize.Small}
                            icon={faEdit}
                        />
                        <IconButton
                            id='Disabled Blue Edit Button With No Count'
                            theme={IconButtonTheme.Blue}
                            handleClick={buttonClick}
                            size={IconButtonSize.Small}
                            icon={faEdit}
                            disabled={true}
                        />
                    </DemoStack>
                </Panel>
            </DemoPageSection>
        </DemoPage>
    );
};
